/**
 * @generated SignedSource<<4c12185a4114e4f20a688ab9afef8154>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadSource = "DOC2_U" | "PATIENT" | "SOFIA";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
import { FragmentRefs } from "relay-runtime";
export type AppointmentAttachmentFragment$data = ReadonlyArray<{
  readonly attachmentType: DocumentType;
  readonly fileName: string;
  readonly id: string;
  readonly thumbnailUrl: string | null;
  readonly uploadDate: string;
  readonly uploadSource: FileUploadSource;
  readonly uploadStatus: FileUploadStatus | null;
  readonly url: string;
  readonly " $fragmentType": "AppointmentAttachmentFragment";
}>;
export type AppointmentAttachmentFragment$key = ReadonlyArray<{
  readonly " $data"?: AppointmentAttachmentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppointmentAttachmentFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AppointmentAttachmentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attachmentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uploadSource",
      "storageKey": null
    }
  ],
  "type": "AppointmentAttachment",
  "abstractKey": null
};

(node as any).hash = "0707b39f427e7dd3ca7a057084c6e291";

export default node;
